import { render, staticRenderFns } from "./CaratulaExpediente.vue?vue&type=template&id=c60eb4c8&scoped=true&"
import script from "./CaratulaExpediente.vue?vue&type=script&lang=js&"
export * from "./CaratulaExpediente.vue?vue&type=script&lang=js&"
import style0 from "./CaratulaExpediente.vue?vue&type=style&index=0&id=c60eb4c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60eb4c8",
  null
  
)

export default component.exports